var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from "react";
import { getFieldConfig, isCashOutField, isFieldValid } from "../services/dfUtils";
import { resolveFieldComponent } from "./fieldType/registry";
import { useFlow, useFlowDispatch } from "../hooks/df";
import { saveToDfStorage } from "../services/helperLib";
import { maybeLoadAgentsForSearch } from "../services/agentSearchUtils";
export default function Question(_a) {
    var _b;
    var fieldId = _a.fieldId;
    var flow = useFlow();
    var fieldConfig = getFieldConfig(fieldId);
    if (!fieldConfig)
        throw new Error("Field config not found for id: ".concat(fieldId));
    var field = flow.formData[fieldId] || {
        config: fieldConfig,
        value: fieldConfig.defaultValue,
    };
    var _c = isFieldValid(field.fieldValue || fieldConfig.defaultValue, fieldConfig), valid = _c.valid, errorMsg = _c.errorMsg;
    var _d = useState(false), touched = _d[0], setTouched = _d[1];
    var dispatch = useFlowDispatch();
    if (!dispatch) {
        console.error("Flow dispatch is not available");
        return null;
    }
    useEffect(function () {
        var _a;
        if (!flow.formData[fieldId]) {
            dispatch({
                type: "UpdateFormData",
                formData: (_a = {},
                    _a[fieldId] = {
                        config: fieldConfig,
                        fieldValue: fieldConfig.defaultValue,
                        isValid: valid,
                    },
                    _a),
            });
        }
    }, []);
    var onChange = function (newVal, isBlurred) {
        var _a;
        if (isBlurred === void 0) { isBlurred = false; }
        var _b = isFieldValid(newVal, fieldConfig), valid = _b.valid, errorMsg = _b.errorMsg;
        if (isBlurred || (isCashOutField(fieldConfig.fieldId) && !valid && !!newVal)) {
            setTouched(true);
        }
        var fieldData = __assign(__assign({}, field), { fieldValue: newVal, errorMessage: errorMsg, isValid: valid });
        if (fieldId === 'loanPurpose' && newVal !== field.fieldValue) {
            dispatch({ type: "ResetFormData" });
        }
        if (isCashOutField(fieldConfig.fieldId) && valid) {
            setTouched(false);
        }
        dispatch({
            type: "UpdateFormData",
            autoNext: fieldConfig.type === "radio",
            formData: (_a = {}, _a[fieldId] = fieldData, _a),
        });
        if (fieldId)
            saveToDfStorage(fieldId, newVal);
        if (fieldConfig.fieldId === "HearAboutUs" ||
            fieldId.endsWith("_HearAboutUs")) {
            maybeLoadAgentsForSearch(newVal);
        }
    };
    var onBlur = function () { return setTouched(true); };
    if (!field) {
        dispatch({
            type: "UpdateFormData",
            formData: (_b = {},
                _b[fieldId] = {
                    config: fieldConfig,
                    fieldValue: fieldConfig.defaultValue,
                    isValid: valid,
                },
                _b),
        });
    }
    var FieldComponent = resolveFieldComponent(fieldConfig);
    var element = React.createElement(FieldComponent, {
        field: field,
        flow: flow,
        onChange: onChange,
        onBlur: onBlur,
        dispatch: dispatch,
        touched: touched,
        isLastStep: flow.isLastStep,
    });
    return (_jsxs("div", { className: "question", children: [element, touched && !valid && (_jsx("span", { className: "error-msg", children: field.errorMessage || errorMsg }))] }));
}
